import { CREATE_PROYECTS, GET_PROYECTS, UPDAT_EPROYECTS, DELETE_PROYECTS } from '../Action-types';

const initialState = {
  projects: [],
  loading: false, // ← era `true`, causaba spinner infinito si fallaba la carga
  error: null,
};

const projectReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_PROYECTS:
      return { ...state, projects: action.payload, loading: false, error: null };
    case CREATE_PROYECTS:
      return { ...state, projects: [...state.projects, action.payload], loading: false };
    case UPDAT_EPROYECTS:
      return {
        ...state,
        projects: state.projects.map((p) => p._id === action.payload._id ? action.payload : p),
        loading: false,
      };
    case DELETE_PROYECTS:
      return { ...state, projects: state.projects.filter((p) => p._id !== action.payload), loading: false };
    default:
      return state;
  }
};

export default projectReducer;
